import React, { Component } from 'react';
import {observer} from "mobx-react"
import ReactAudioPlayer from 'react-audio-player';
import vmsg from "vmsg";
import { ReactMic } from 'react-mic';
import EntreeStore from "../EntreeStore"
import axios from "axios"
import { HashRouter as Router, Route, Link } from "react-router-dom";
import 'react-html5-camera-photo/build/css/index.css';
import Recorder from "../Recorder"

@observer
class Audios extends React.Component {
  constructor(props) {
    super(props);
    this.loadRecords = this.loadRecords.bind(this)
    this.deleteAudio = this.deleteAudio.bind(this)

    this.state = {
      piece_id: this.props.match.params.pieceid,
      isLoading: false,
      isRecording: false,
      recordings: [],
      savedRecords: [],
      blobs: [],
      record: false

    };
    EntreeStore.loadPieces()
    this.loadRecords()
  }
  loadRecords(){
    axios.post("/api/v1/experts/app/entree/dashboard/loadAudios",{id: EntreeStore.rdv.id,expertiseid: this.props.expertiseid,piece: this.props.match.params.pieceid}).then((data)=>{
      this.setState({savedRecords: data.data})
    })
  }
  deleteAudio(e){
    e.preventDefault()
    console.log(e.target)
    let id = e.target.dataset.audio
    axios.post("/api/v1/experts/app/entree/dashboard/deleteAudios",{id: EntreeStore.rdv.id,expertiseid: this.props.expertiseid,piece: this.props.match.params.pieceid,audio: id}).then((data)=>{
      this.loadRecords()
    })
  }
  render() {
    const { record, recordings } = this.state;

    if(EntreeStore.loaded){
      return(
        <div className ="row">
{/*        <div className="row">
          <Link className="btn col s2 offset-s1" to={"/expertise/piece/"+this.props.match.params.pieceid+"/backward"} ><i className="material-icons left">keyboard_backspace</i>Canvas</Link>
          <Link className="btn col s2 offset-s1" to={"/expertise/photo/"+this.props.match.params.pieceid+"/"+this.props.match.params.expertiseid} ><i className="material-icons left">add_a_photo</i>Photos</Link>
        </div>*/}
        <div className="row">
          <div className="col s12">
          <div className="row">

          </div>
          <div className="row center">
          <Recorder
          endpoint="/api/v1/experts/app/entree/dashboard/savaAudios"
          data={{id: EntreeStore.rdv.id,
            piece: this.props.match.params.pieceid,
            expertiseid: this.props.expertiseid
          }}
          callback={this.loadRecords}
           />
          </div>

          <div className="diviser"></div>
          <p className="center">Audios déjà sauvés</p>
          <table>
              <tbody>
              <tr>
                <th></th>
                <th></th>
              </tr>
              </tbody>
              <tbody>
              {this.state.savedRecords.map((audio,index) => (
                <tr key={audio.id}>
                  <td><audio preload="auto" src={audio.url} controls /></td>
                  <td><a href="" onClick={this.deleteAudio} data-audio={audio.id} ><i data-audio={audio.id} className="material-icons red-text">delete</i></a></td>
                </tr>
              ))}
              </tbody>
            </table>
            </div>
        </div>
        </div>
        )
    }else{
     return (
        <div>
        Chargement en cours
        </div>
      );
   }
  }
}



export default Audios
